import { Action } from 'redux';
import { RunFlow } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { IContentInfo } from '../../ts/models/IContentInfo';

export interface RunFlowReduxAction extends Action {
  readonly selectedContent: IContentInfo[];
}

export function runFlow(selectedContent: IContentInfo[]): RunFlowReduxAction {
  return {
    type: RunFlow,
    selectedContent
  };
}

export const isRunFlowsAction = isActionFactory<RunFlowReduxAction>(RunFlow);
